import { PolarisBreakPoint } from '@/constants/enum';
import styled from 'styled-components';

export const StyledTemplateEditor = styled.div`
  [id*='editor'] {
    overflow: auto;
  }

  @media screen and (max-width: ${PolarisBreakPoint.LG}) {
    [id*='editor'] {
      overflow: auto;
    }
  }
`;
